import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionReveal } from '../ui/SectionReveal';
const faqs = [{
  q: '¿Es seguro si ya tomo Metformina?',
  a: 'Es un plan nutricional y de suplementos naturales; siempre recomendamos validarlo con tu doctor, pero está diseñado para ser mínimamente invasivo.'
}, {
  q: '¿Tengo que comprar suplementos caros?',
  a: 'No, los aliados que recomendamos son accesibles y fáciles de encontrar en cualquier tienda naturista o farmacia.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí, un solo pago y recibes todo el material digital de inmediato.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionReveal bgColor="mint" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <div className="text-center mb-12" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A1A2E] mb-4" data-id="element-26">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-gray-600" data-id="element-27">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-29">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-30">
                  <span className="text-lg font-bold text-[#1A1A2E] pr-8" data-id="element-31">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="shrink-0 text-[#0D6E6E]" data-id="element-32">
                    <ChevronDown className="w-6 h-6" data-id="element-33" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-34">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-35">
                      <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-36">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </SectionReveal>;
}